var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7887_530856)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "#735EA5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7887_530856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7887_530856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 29.0275L41.4463 57.7706L31.2219 63.5156L33.7219 66.0419L33.2513 66.3419L46.9094 80H79.9981V40.0975L59.9463 20L32.1331 22.2762L26.2813 28.1281L12.7031 29.0275Z",
    fill: "#684E9B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1134 67.2508H35.2966C33.7734 67.2508 32.5391 66.0158 32.5391 64.4933V59.887C32.5391 58.3639 33.7741 57.1289 35.2972 57.1289H57.1141C58.6372 57.1289 59.8722 58.3639 59.8722 59.887V64.4933C59.8716 66.0164 58.6366 67.2508 57.1134 67.2508Z",
    fill: "#433644"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1367 38.2695L34.5198 44.8514C35.1298 46.5364 36.7305 47.6589 38.5223 47.6589H47.4198",
    stroke: "#F6F7F7",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2374 38.1641L38.6662 44.4234C38.5712 44.8166 38.8693 45.1953 39.2737 45.1953H43.5968L40.2374 38.1641Z",
    fill: "#EF6C88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6678 57.1288H46.5928L40.4141 39.5782L53.6578 37.7363L55.6678 57.1288Z",
    fill: "#FFCC04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6669 30.2111H15.5819C14.5038 30.2111 13.4694 29.7855 12.7031 29.0267C12.2031 28.5311 12.2031 27.723 12.7031 27.2273C13.4694 26.4686 14.5038 26.043 15.5819 26.043H36.6669V30.2111Z",
    fill: "#D3DBE2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7887_530856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 26,
    width: 25,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6669 30.2111H15.5819C14.5038 30.2111 13.4694 29.7855 12.7031 29.0267C12.2031 28.5311 12.2031 27.723 12.7031 27.2273C13.4694 26.4686 14.5038 26.043 15.5819 26.043H36.6669V30.2111Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7887_530856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7919 24.9434L11.8281 30.9071",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6669 24.9434L15.7031 30.9071",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5413 24.9434L19.5781 30.9071",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4169 24.9434L23.4531 30.9071",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2919 24.9434L27.3281 30.9071",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1663 24.9434L31.2031 30.9071",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8962 35.7552H29.9206V19.8809H28.8962C26.4681 19.8809 24.5 21.849 24.5 24.2771V31.359C24.5 33.7871 26.4687 35.7552 28.8962 35.7552Z",
    fill: "#433644"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.65 39.7454H32.76C31.1925 39.7454 29.9219 38.4748 29.9219 36.9073V19.3479C29.9219 17.7804 31.1925 16.5098 32.76 16.5098H51.65C58.0663 16.5098 63.2675 21.711 63.2675 28.1273C63.2675 34.5441 58.0663 39.7454 51.65 39.7454Z",
    fill: "#FFCC04"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7887_530856",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 37,
    width: 16,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6678 57.1288H46.5928L40.4141 39.5782L53.6578 37.7363L55.6678 57.1288Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7887_530856)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0334 53.4233H50.9284C50.2672 53.4233 49.7266 52.8827 49.7266 52.2214C49.7266 51.5602 50.2672 51.0195 50.9284 51.0195H59.0328C59.6941 51.0195 60.2347 51.5602 60.2347 52.2214C60.2353 52.8827 59.6941 53.4233 59.0334 53.4233Z",
    fill: "#F39C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.035 44.2983H47.7956C47.1344 44.2983 46.5938 43.7577 46.5938 43.0964C46.5938 42.4352 47.1344 41.8945 47.7956 41.8945H59.0344C59.6956 41.8945 60.2363 42.4352 60.2363 43.0964C60.2369 43.7577 59.6956 44.2983 59.035 44.2983Z",
    fill: "#F39C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0355 48.8608H49.2448C48.5836 48.8608 48.043 48.3202 48.043 47.6589C48.043 46.9977 48.5836 46.457 49.2448 46.457H59.0355C59.6967 46.457 60.2373 46.9977 60.2373 47.6589C60.2373 48.3202 59.6961 48.8608 59.0355 48.8608Z",
    fill: "#F39C1E"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0358 51.0195H52.9439L53.2695 53.4233H55.2852L55.0358 51.0195ZM54.5627 46.4577H52.3452L52.6708 48.8614H54.812L54.5627 46.4577ZM54.0902 41.8945H51.7227L52.072 44.2983H54.3395L54.0902 41.8945Z",
    fill: "#F39C1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5391 62.1895H60.0372",
    stroke: "#342934",
    strokeWidth: 3.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9425 36.9079V19.3479C32.9425 17.7804 34.2131 16.5098 35.7806 16.5098H32.76C31.1925 16.5098 29.9219 17.7804 29.9219 19.3479V36.9073C29.9219 38.4748 31.1925 39.7454 32.76 39.7454H35.7806C34.2125 39.7454 32.9425 38.4748 32.9425 36.9079Z",
    fill: "#FFDB4B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M51.6495 16.5098H48.6289C55.0452 16.5098 60.2464 21.711 60.2464 28.1273C60.2464 34.5435 55.0452 39.7448 48.6289 39.7448H51.6495C58.0658 39.7448 63.267 34.5435 63.267 28.1273C63.267 21.711 58.0658 16.5098 51.6495 16.5098Z",
    fill: "#F39C1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0078 20.5877C36.0078 20.1971 36.3241 19.8809 36.7147 19.8809H45.7284C46.1184 19.8809 46.4353 20.1971 46.4353 20.5877C46.4353 20.9784 46.1191 21.2946 45.7284 21.2946H36.7147C36.3247 21.2946 36.0078 20.9784 36.0078 20.5877Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0078 24.0389C36.0078 23.6483 36.3241 23.332 36.7147 23.332H45.7284C46.1184 23.332 46.4353 23.6483 46.4353 24.0389C46.4353 24.4295 46.1191 24.7458 45.7284 24.7458H36.7147C36.3247 24.7458 36.0078 24.4295 36.0078 24.0389Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0078 27.492C36.0078 27.1014 36.3241 26.7852 36.7147 26.7852H45.7284C46.1184 26.7852 46.4353 27.1014 46.4353 27.492C46.4353 27.8827 46.1191 28.1989 45.7284 28.1989H36.7147C36.3247 28.1989 36.0078 27.8827 36.0078 27.492Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7887_530856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.7b5d9ea41e021b13589056c9a862c4b0.svg";
export { ForwardRef as ReactComponent };